import React, { useMemo } from 'react';
import UsDatePicker from '../UsDatePicker';
import {
  ATTENDANCE_MAX_RANGE_DAYS,
  getAttendanceRangeError,
  maxEndDateForStart,
  normalizeAttendanceRange,
} from '../../utils/attendanceDateRange';
import { todayIsoLocal } from '../../utils/usDateFormat';

export default function AttendanceDateRangeFilter({
  startDate,
  endDate,
  onStartChange,
  onEndChange,
  dateError: externalDateError,
  idPrefix = 'attendance',
  compact = false,
}) {
  const computedError = useMemo(
    () => getAttendanceRangeError(startDate, endDate),
    [startDate, endDate]
  );
  const dateError = externalDateError || computedError;
  const endMax = maxEndDateForStart(startDate);

  const handleStartChange = (iso) => {
    const { startDate: nextStart, endDate: nextEnd } = normalizeAttendanceRange(
      iso,
      endDate
    );
    onStartChange(nextStart);
    onEndChange(nextEnd);
  };

  const handleEndChange = (iso) => {
    onEndChange(iso);
  };

  const labelClass = compact
    ? 'block text-sm font-medium text-gray-700 mb-1'
    : undefined;
  const pickerClass = compact
    ? 'w-full border border-gray-300 rounded-md px-3 py-2 pr-12 text-sm focus:outline-none focus:border-[#674936]'
    : undefined;

  return (
    <div className="flex flex-wrap items-end gap-4">
      <div className={compact ? 'w-full sm:max-w-xs' : 'w-full sm:max-w-xs'}>
        <UsDatePicker
          id={`${idPrefix}-start-date`}
          label={compact ? 'Start Date' : 'Start Date'}
          value={startDate}
          onChange={handleStartChange}
          max={todayIsoLocal()}
          hint={
            compact
              ? `Up to ${ATTENDANCE_MAX_RANGE_DAYS} days`
              : `Select up to ${ATTENDANCE_MAX_RANGE_DAYS} days. Start date cannot be in the future.`
          }
          labelClassName={labelClass}
          inputClassName={pickerClass}
        />
      </div>
      <div className={compact ? 'w-full sm:max-w-xs' : 'w-full sm:max-w-xs'}>
        <UsDatePicker
          id={`${idPrefix}-end-date`}
          label={compact ? 'End Date' : 'End Date'}
          value={endDate}
          onChange={handleEndChange}
          min={startDate || undefined}
          max={endMax}
          onBelowMin={() => {}}
          onAboveMax={() => {}}
          labelClassName={labelClass}
          inputClassName={pickerClass}
        />
      </div>
      {dateError ? (
        <p className="text-red-500 text-sm w-full pb-2">{dateError}</p>
      ) : null}
    </div>
  );
}
